import { Link, Typography } from "@mui/material";
import { MRT_ColumnDef } from "material-react-table";
import { formatUTCDateWithLocalTime } from "../../../utils";
import { PersonRecord, Role } from "./types";

export const individualColumns = (roleList: Role[]): MRT_ColumnDef<PersonRecord>[] => [
  {
    accessorKey: "createdDate",
    header: "Created Date",
    size: 50,
    accessorFn: (row) => (row.history ? formatUTCDateWithLocalTime(row.history[0]?.date) : null),
    Cell: ({ renderedCellValue, row }) => <Typography>{formatUTCDateWithLocalTime(row.original.history[0]?.date)}</Typography>,
    muiTableBodyCellProps: { sx: { verticalAlign: "top" } },
    muiFilterTextFieldProps: { variant: "outlined", size: "small" }
  },
  {
    accessorKey: "createdByUser",
    header: "Created By",
    size: 50,
    Cell: ({ renderedCellValue, row }) => <Typography>{row.original.history[0]?.username}</Typography>,
    muiTableBodyCellProps: { sx: { verticalAlign: "top" } },
    muiFilterTextFieldProps: { variant: "outlined", size: "small" }
  },
  {
    accessorFn: (row) =>
      `${row.firstName ?? ""} ${row.lastName ?? ""}`,
    id: "name",
    header: "Name",
    size: 50,
    muiTableBodyCellProps: { sx: { verticalAlign: "top" } },
    muiFilterTextFieldProps: { variant: "outlined", size: "small" },
    Cell: ({ row }) => (
      <Link
        href={`/phonebook/contact/profile?id=${row.original.id}`}
        target="_blank"
        rel="noopener noreferrer"
        underline="hover"
      >
        <Typography variant="body2">
          {String(row.original.firstName ?? "")} {String(row.original.lastName ?? "")}
        </Typography>
      </Link>
    )
  },
  
  {
    accessorFn: (row) => row.contactRoles?.[0]?.businessEmail || "",
    id: "businessEmail",
    header: "Email",
    size: 50,
    Cell: ({ cell }) => <Typography>{String(cell.getValue() ?? "")}</Typography>,
    muiTableBodyCellProps: { sx: { verticalAlign: "top" } },
    muiFilterTextFieldProps: { variant: "outlined", size: "small" }
  },
  {
    accessorFn: (row) => row.contactRoles?.[0]?.branch?.company?.name || "",
    id: "company",
    header: "Company",
    size: 50,
    Cell: ({ cell }) => <Typography>{String(cell.getValue() ?? "")}</Typography>,
    muiTableBodyCellProps: { sx: { verticalAlign: "top" } },
    muiFilterTextFieldProps: { variant: "outlined", size: "small" }
  },
  {
    accessorKey: "role",
    header: "Role",
    size: 50,
    Cell: ({ row }) => {
      const role = roleList.find((r: Role) => r.id === row.original.contactRoles?.[0]?.roleId);
      return <Typography>{role?.name}</Typography>;
    },
    muiTableBodyCellProps: { sx: { verticalAlign: "top" } },
    muiFilterTextFieldProps: { variant: "outlined", size: "small" }
  },
  {
    accessorFn: (row) =>
      `${row.contactRoles?.[0]?.branch?.address1 ?? ""} ${row.contactRoles?.[0]?.branch?.city ?? ""} ${row.contactRoles?.[0]?.branch?.state ?? ""} ${row.contactRoles?.[0]?.branch?.zip ?? ""}`,
    id: "address",
    header: "Address",
    size: 50,
    Cell: ({ cell }) => (
      <Typography>
        {String(cell.getValue() ?? "")}
      </Typography>
    ),
    muiTableBodyCellProps: { sx: { verticalAlign: "top" } },
    muiFilterTextFieldProps: { variant: "outlined", size: "small" }
  }
];
